import { Col, Row, Radio, DatePicker, Button } from "antd";
import React, { useEffect, useState } from "react";
import Charts from "./chart";
import OCharts from "./ochart";
const { RangePicker } = DatePicker;

export default () => {
  const [value, setValue] = useState("month");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [date, setDate] = useState([]);
  const [date1, setDate1] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [moneyUseType, setMoneyUseType] = useState("1");

  useEffect(() => {
    setChartData([1, 2, 3]);
  }, []);

  const reset = () => {
    setDate([]);
  };

  const reset1 = () => {
    setDate1([]);
  };

  return (
    <div className="revenue" style={{ padding: 10 }}>
      <Row gutter={20}>
        <Col span={4}>
          <Radio.Group
            style={{ width: "100%" }}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button className="button-children" value="month">
              月
            </Radio.Button>
            <Radio.Button className="button-children" value="square">
              季度
            </Radio.Button>
            <Radio.Button className="button-children" value="year">
              年
            </Radio.Button>
          </Radio.Group>
        </Col>
        <Col span={10}>
          <Row>
            <Col span={16}>
              <div>
                开始日期：
                <RangePicker value={date} onChange={(e) => setDate(e)} />
              </div>
            </Col>
            <Col span={8}>
              <Button onClick={reset}>重置</Button>
              <Button
                type="primary"
                loading={loading}
                style={{ marginLeft: 8 }}
              >
                查询
              </Button>
            </Col>
          </Row>
          {moneyUseType == 2 && (
            <Row style={{ marginTop: 20 }}>
              <Col span={16}>
                <div>
                  开始日期：
                  <RangePicker value={date1} onChange={(e) => setDate1(e)} />
                </div>
              </Col>
              <Col span={8}>
                <Button onClick={reset1}>重置</Button>
                <Button
                  type="primary"
                  loading={loading1}
                  style={{ marginLeft: 8 }}
                >
                  查询
                </Button>
              </Col>
            </Row>
          )}
        </Col>
        <Col span={4}>
          <Radio.Group
            style={{ width: "100%" }}
            value={moneyUseType}
            onChange={(e) => setMoneyUseType(e.target.value)}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button className="button-children" value="1">
              同比
            </Radio.Button>
            <Radio.Button className="button-children" value="2">
              环比
            </Radio.Button>
          </Radio.Group>
        </Col>
      </Row>
      <Row gutter={20}>
        <Col span={12}>
          <Charts data={chartData} height={700} />
        </Col>
        <Col span={12}>
          <OCharts data={chartData} height={700} />
        </Col>
      </Row>
    </div>
  );
};
